<template>
  <div class="container">    
      <!-- 评价 -->
    <div style="background-color:#ffffff">
      <div class="evaluation">
        <span>描述相符</span>
        <van-rate v-model="value" readonly v-if="isEvaluate == 1"/>
         <van-rate v-model="value" v-if="isEvaluate == 0"/>
      </div>
      <div class="textarea">
        <textarea v-reset-page  name id cols="30" rows="10" placeholder="请输入想要的内容" :value="content" disabled v-if="isEvaluate == 1"></textarea>
        <textarea v-reset-page  name id cols="30" rows="10" placeholder="请输入想要的内容" v-model="content" v-if="isEvaluate == 0"></textarea>
      </div>
    </div>
    <div class="btn" @click="handleSaveClick" v-if="isEvaluate == 0">评价</div>
  </div>
</template>
<script>
import { Rate, Toast } from "vant";
import { Evaluate,echoEvaluate} from "@/api/public"
export default {
  components: {
    vanRate: Rate
  },
  data() {
    return {
      value: 0,
      content:'',
      isEvaluate:''
    };
  },
  mounted() {
    this.requestListDetail()
  },
  methods:{
     requestListDetail() {
      let formIdOrWorkId = this.$utils.getUrlKey('maintenanceFormId')
       echoEvaluate({maintenanceFormId:formIdOrWorkId}).then(res=>{
          console.log(res)
          if (res.code == 200) {
               if (res.data.isEvaluate == 0) {
                   return
               }
               if (res.data.isEvaluate == 1) {
                    this.value = res.data.grade 
                    this.content = res.data.evaluateContent
                    this.isEvaluate = res.data.isEvaluate
               }
          }
       })
     },
    // 评价
      requestEvaluate() {
          let content = this.content
          let value = this.value
          if(!JSON.stringify(value)) {
               Toast('请选择星级')
               return false
          }
          if(!content) {
              Toast('请输入评价')
              return false
          }
          let formIdOrWorkId =  this.$utils.getUrlKey('maintenanceFormId')
           Evaluate({content:content,grade:value,type:0,formIdOrWorkId:formIdOrWorkId}).then(res=>{
               console.log(res)
               if(res.code == 200) {
                  this.$router.go(-1)
               }
           })
      },
    handleSaveClick() {
        this.requestEvaluate()
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  .checking-information {
      background-color: #ffffff;
        font-size: 15px;
        text-align: left;
        padding: 0 13px;
        box-sizing: border-box;
      .information-title {
        width: 100%;
        height: 54px;
        line-height: 50px;
        border-bottom: 2px solid #f9f9f9;
        text-align: left;
        color: #333333; 
        overflow: hidden;
      }
      .information-content {
           padding: 10px 0;
           box-sizing: border-box;
           .information-list {
            //    height: 40px;
            //    line-height: 40px;
             margin-top: 20px;
               .situation {
                   float: left;
                   vertical-align: middle;
               }
               .situation-img {
                   float: left;
                   margin-top: 20px;
               }
               .situation-content {
                  display: inline-block;
                  width: 78%;
                  img {
                    vertical-align: top;
                    width: 60px;
                    height: 60px;
                  }
               }
           }
      }
  }
  .block {
      width: 100%;
      height: 10px;
      background-color: #f6f6f6
  }
  .evaluation {
    width: 100%;
    height: 54px;
    line-height: 50px;
    padding: 0 13px;
    box-sizing: border-box;
    border-bottom: 2px solid #f9f9f9;
    text-align: left;
    color: #333333;
    font-size: 15px;
    overflow: hidden;
    span {
      margin-right: 10px;
      vertical-align: middle;
    }
  }
  .textarea {
    width: 100%;
    height: 180px;
    padding: 14px 13px;
    box-sizing: border-box;
    textarea {
      width: 100%;
      height: 100%;
      border: none;
      font-size: 14px;
      color: #999999;
      &::-webkit-input-placeholder {
        color: #999999;
        font-size: 14px;
      }
      &:disabled {
         background-color: #ffffff
      }
    }
  }
   .btn {
        width: 350px;
        height: 44px;
        background: -webkit-linear-gradient(left, #05AEFC, #008CFF);
        margin: 0 auto;
        border-radius: 22px;
        font-size: 16px;
        color: $white-color;
        line-height: 44px;
        margin:20px auto;
     }
}
</style>
<style lang="scss">
.van-rate {
  vertical-align: middle;
}
</style>
